module.exports = __webpack_public_path__ + "static/tat-41-f983fd6018120833b191e881bd34a930.jpg";